import { ReactNode, useEffect } from 'react';

import { Affix, Box, Group } from '@mantine/core';

import { useIsMobile } from 'hooks/use-is-mobile';

import cx from './StickyActions.module.scss';

const StickyActions = ({ mobile, desktop }: { mobile: ReactNode; desktop: ReactNode }) => {
    const isMobile = useIsMobile('sm');

    // The scan notes sheet reads this to sit above the actions instead of on top of them
    useEffect(() => {
        document.body.setAttribute('data-sticky-actions', '');

        return () => document.body.removeAttribute('data-sticky-actions');
    }, []);

    return isMobile ? (
        <Box className={cx.bar}>{mobile}</Box>
    ) : (
        <Affix position={{ bottom: 'var(--mantine-spacing-md)', right: 'var(--mantine-spacing-md)' }} zIndex={199}>
            <Group gap={8}>{desktop}</Group>
        </Affix>
    );
};

export { StickyActions };
